// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"84656f8e","399":"003dfb90","474":"4090afd0"}[chunkId] + ".chunk.css";
};